import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useAuth } from './authContext';

const stringToColour = (str: string) => {
  let hash = 0;
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, '0');
  }
  return colour;
};

export const AuthStatus = () => {
  const { username, isAuthenticated, signout } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (
      !confirm('Are you sure you want to log out of your current session ?')
    ) {
      return;
    }
    signout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex justify-end">
      {!isAuthenticated ? (
        <p>You are not logged in.</p>
      ) : (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="relative rounded-full uppercase select-none"
              style={{
                backgroundColor: stringToColour(username ?? '..'),
              }}
            >
              {username?.slice(0, 2)}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onSelect={handleSubmit}>
              Sign out
            </DropdownMenuItem>
            {/* fromApp: the page's Back may return here (routes/account.tsx). */}
            <DropdownMenuItem asChild>
              <Link to="/account" state={{ fromApp: true }}>
                My account
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
